module.exports = __webpack_public_path__ + "img/test.8ac17f8b.png";